import { IEntity } from "@interfaces/entity"
import { User } from "@models/identity/user"

export class DeliveryNoteSettings implements IEntity {
  id: number
  ownerUserId: string
  owner: User
  
  fileNameFirstVariable: string
  fileNameSecondVariable: string
  fileNameThirdVariable: string

  isCreatedMonthly: boolean

  entityName = "DeliveryNoteSettings"

  constructor(formValue?: Partial<DeliveryNoteSettings>) {
    Object.assign(this, formValue)
  }

  updateValues(formValue: Partial<DeliveryNoteSettings>) {
    Object.assign(this, formValue)
  }

  getPrimaryKey() {
    return this.id
  }
}
